export default __webpack_public_path__ + "static/media/Next IT - Comple (3).bfaaeb34.png";